import { CustomerLocationsView } from './CustomerLocationsView';
import { ModalRoutingService } from 'services';

export const CustomerLocationsComponentMap = {
  CustomerLocationsView,
};

export const customerLocationsModalRoutingService = new ModalRoutingService(
  'customerLocations',
  'CustomerLocationsView',
  CustomerLocationsComponentMap,
  { customerId: 'string' },
  ['CustomerLocationsView'],
);
